// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application';

import FeedController from './feed_controller';
application.register('feed', FeedController);

import PasswordVisibilityController from './password_visibility_controller';
application.register('password-visibility', PasswordVisibilityController);

import ChoiceSelectController from './choice_select_controller';
application.register('choice-select', ChoiceSelectController);

import DialogController from './dialog_controller';
application.register('dialog', DialogController);

import DrawerController from './drawer_controller';
application.register('drawer', DrawerController);

import ChatInputController from './conversation/chat_input_controller';
application.register('chat-input', ChatInputController);

import RecaptchaV2Controller from './recaptcha_v2_controller';
application.register('recaptcha-v2', RecaptchaV2Controller);

import SubscriptionPriceFormController from './creator/subscription_price_form_controller';
application.register('creator--subscription-price-form', SubscriptionPriceFormController);

import DisableContextMenuController from './disable_context_menu_controller';
application.register('disable-context-menu', DisableContextMenuController);

import BulkMessageFormController from './creator/bulk_message_form_controller';
application.register('creator--bulk-message-form', BulkMessageFormController);

import ContentFilterFormController from './content_filter_form_controller';
application.register('content-filter-form', ContentFilterFormController);

import ModalController from './modal_controller';
application.register('modal', ModalController);

import FlashController from '../../components/flash/flash_controller';
application.register('flash', FlashController);

import PostCreateController from './creator/posts/create_controller';
application.register('creator-post-create', PostCreateController);

import PostLikeButtonController from './posts/like_button_controller';
application.register('creator--posts--like-button', PostLikeButtonController);

import ContentCreateController from './creator/content/create_controller';
application.register('creator-content-create', ContentCreateController);

import InspirationPresetController from './creator/video_generations/inspiration_preset_controller';
application.register(
  'creator--video-generations--inspiration-preset',
  InspirationPresetController
);

import CreateController from './creator/video_generations/create_controller';
application.register('creator--video-generations--create', CreateController);

import EmojiAutocompleteController from './emoji_autocomplete_controller';
application.register('emoji-autocomplete', EmojiAutocompleteController);

import ConversationShowController from './conversation/show_controller';
application.register('conversation-show', ConversationShowController);

import DropzoneController from './dropzone_controller';
application.register('dropzone', DropzoneController);

import ProfileController from './profile_controller';
application.register('profile', ProfileController);

import SwiperController from './creator/content/swiper_controller';
application.register('creator-content-swiper', SwiperController);

import ProfilePhotoUpdateController from './profile_photo_update_controller';
application.register('profile-photo-update', ProfilePhotoUpdateController);

import BannerPhotoUpdateController from './banner_photo_update_controller';
application.register('banner-photo-update', BannerPhotoUpdateController);

import ChatController from './conversation/chat_controller';
application.register('chat', ChatController);

import CreatorContentBulkSelectionController from './creator/content/bulk_selection_controller';
application.register(
  'creator-content-bulk-selection',
  CreatorContentBulkSelectionController
);

import CreatorContentBulkMessagePotentialRecipientsController from './creator/content/bulk_message_potential_recipients_controller';
application.register(
  'creator-content-bulk-message-potential-recipients',
  CreatorContentBulkMessagePotentialRecipientsController
);

import CreatorOnboardingController from './creator/onboarding_controller';
application.register('creator--onboarding', CreatorOnboardingController);

import CreatorPayoutMethodsFormController from './creator/payout_methods_form_controller';
application.register(
  'creator--payout-methods-form',
  CreatorPayoutMethodsFormController
);

import CreatorStatementController from './creator/statement_controller';
application.register('creator--statement', CreatorStatementController);

import ButtonSpinnerController from './button_spinner_controller';
application.register('button-spinner', ButtonSpinnerController);

import VideoPlayerController from './video_player_controller';
application.register('video-player', VideoPlayerController);

import HomeSwiperController from './home/swiper_controller';
application.register('home--swiper', HomeSwiperController);

import HomeSwiperSuggestionController from './home/swiper_suggestion_controller';
application.register('home--swiper-suggestion', HomeSwiperSuggestionController);

import CreatorContentSwiperController from './creator/content/swiper_controller';
application.register(
  'creator--content--swiper',
  CreatorContentSwiperController
);

import TabsController from './tabs_controller';
application.register('tabs', TabsController);

import AdminChartsController from './admin/charts_controller';
application.register('admin--charts', AdminChartsController);

import AdminImageModalController from './admin/image_modal_controller';
application.register('admin--image-modal', AdminImageModalController);

import SeeMoreController from './see_more_controller';
application.register('see-more', SeeMoreController);

import ToggleController from './libraries/toggle_controller';
application.register('toggle', ToggleController);

import ClipboardController from './libraries/clipboard_controller';
application.register('clipboard', ClipboardController);

import CommentCreateController from './comments/create_controller';
application.register('comments--create', CommentCreateController);

import ToastItemController from './toast_item_controller';
application.register('toast-item', ToastItemController);

import ToastContainerController from './toast_container_controller';
application.register('toast-container', ToastContainerController);

import ContentSelectorController from './content_selector_controller';
application.register('content-selector', ContentSelectorController);

import PrimerPaymentsController from './primer_payments_controller';
application.register('primer-payments', PrimerPaymentsController);

import RotatedListController from './rotated_list_controller';
application.register('rotated-list', RotatedListController);

import OnboardingCarouselController from './creator/onboarding_carousel_controller';
application.register(
  'creator--onboarding-carousel',
  OnboardingCarouselController
);

import CategorySelectionController from './creator/onboarding/category_selection_controller';
application.register(
  'creator--onboarding-category-selection',
  CategorySelectionController
);

import IdentificationSelectorController from './creator/onboarding/identification_selector_controller';
application.register(
  'creator--onboarding-identification-selector',
  IdentificationSelectorController
);

import SidebarController from './sidebar_controller';
application.register('sidebar', SidebarController);

import CreatorChartsController from './creator/charts_controller';
application.register('creator--charts', CreatorChartsController);

import EditProfileController from './edit_profile_controller';
application.register('edit-profile', EditProfileController);

import LocalTimezoneController from './libraries/local_timezone_controller';
application.register('local-timezone', LocalTimezoneController);

import ConversationInputFormController from './conversation/input_form_controller';
application.register(
  'conversation--input-form',
  ConversationInputFormController
);

import ConversationSearchController from './conversation/search_controller';
application.register('conversation--search', ConversationSearchController);

import ScheduleModalController from './creator/messages/schedule_modal_controller';
application.register(
  'creator--messages--schedule-modal',
  ScheduleModalController
);

import HomeSearchController from './home/search_controller';
application.register('home--search', HomeSearchController);
